export const secureIndex = [
  {
    title: "TRUSTPAY",
    content: "100% safe online payments.",
  },
  {
    title: "PROFESSIONAL & TRAINED STAFF",
    content: "In house training and certification programs.",
  },
  {
    title: "100% HAPPINESS GUARANTEE",
    content: "Customer centricity is our core value.",
  },
  {
    title: "HIGH QUALITY",
    content: "We work with established branded materials.",
  },
  {
    title: "BEST IN CLASS SERVICES / PRODUCTS",
    content: "All services we provide are value for money.",
  },
];
